import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be32818"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "headers"
}
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = {
  key: 0,
  class: "logopb",
  href: "https://www.policybazaar.com"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-height":"33px","margin-top":"0px"},
  alt: "logo",
  class: "policylogo",
  title: "Policy Bazaar",
  src: "https://static.pbcdn.in/term-cdn/images/vue/pbp_web_logo.svg"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "claim-ratio"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static.pbcdn.in/term-cdn/images/vue/claim.png" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "logopb" }),
  /*#__PURE__*/_createTextVNode(" Term Insurance ")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isMobiledevice())
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["containers", {'bazazHead':_ctx.isBajajMarketingId}])
          }, [
            (!_ctx.isMobiledevice())
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!_ctx.isPospUtmSource)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_3))
                    : _createCommentVNode("", true),
                  (_ctx.isPospUtmSource)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isPospUtmSource)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: _ctx.getTermDecalLik
                  }, [
                    _hoisted_9,
                    _createTextVNode(" Claim Assistance")
                  ], 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(["header-mobs", {'bazazHead':_ctx.isBajajMarketingId}])
        }, _hoisted_11, 2))
  ]))
}